module.exports = __webpack_public_path__ + "img/Alerts.1aef309f.svg";